module.exports = __webpack_public_path__ + "img/te-8.92cf5855.png";